import { SelectionChangedEvent } from "ag-grid-community";
import { EMPTY_DOCUMENT_PREVIEW_SEARCH_CRITERIA } from "domain/entity/DocumentPreview/DocumentPreviewSearchCriteria";
import { getDefaultBuConfig } from "domain/repository/apiUtil";
import moment from "moment";
import { AclType } from "presentation/constant/ANAInfo/NbisivPermission";
import { Permission } from "presentation/constant/ANAInfo/PermissionName";
import { transferRowData } from "presentation/constant/DocumentPreview/DocumentPreviewColumnDefinition";
import { DocumentPreviewConstant } from "presentation/constant/DocumentPreview/DocumentPreviewConstant";
import { useDocumentPreviewVM } from "presentation/hook/DocumentPreview/useDocumentPreviewVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { useDocumentPreviewTracked } from "presentation/store/DocumentPreview/DocumentPreviewProvider";
import { isPermissionExist } from "presentation/utils/permissionUtils";
import NbisTable from "presentation/view/components/TableWrapper/NbisTable";
import { TableWrapper } from "presentation/view/components/TableWrapper/TableWrapper";
import { memo, useCallback, useEffect, useMemo, useRef } from "react";
import { Core } from "veronica-ui-component";
import { GroupButtons, Loader } from "veronica-ui-component/dist/component/core";


const DocumentPreviewTablePanel: React.FC = () => {
    const [documentPreviewState] = useDocumentPreviewTracked();
    const documentPreviewVM = useDocumentPreviewVM();
    const gridRef: any = useRef(null);
    const { searchStatus, documentPreviewList, isReadyForFinalize, isReadyForFinalizeCount } = documentPreviewState;
    const DOCUMENT_PREVIEW_CONSTANT = DocumentPreviewConstant.Title;
    // const [onTableSelectionClicked, setOnTableSelectionClicked] = useState<boolean>(false);
    const [anaInfoState] = useANAInfoTracked();
    const { operatingUnit } = anaInfoState;
    const allowUpdateSL = isPermissionExist(Permission.DOCUMENT_PREVIEW_SL, AclType.UPDATE, anaInfoState.defaultOperatingCompany, anaInfoState.allNbisivPermission);
    const allowUpdateCC = isPermissionExist(Permission.DOCUMENT_PREVIEW_CC, AclType.UPDATE, anaInfoState.defaultOperatingCompany, anaInfoState.allNbisivPermission);

    // useEffect(() => {
    //     // const columnDefs = (documentPreviewState.dynamicTableColumns?.slice());

    //     if (!documentPreviewState.selectedRows ||
    //         documentPreviewState.selectedRows.length <= 0) {
    //         //gridRef.current?.gridRef.current.api?.setColumnDefs(columnDefs);
    //         if (!onTableSelectionClicked) {
    //             gridRef.current?.gridRef.current.api?.deselectAll();
    //         }
    //     }
    // })

    // useEffect(() => {
    //     if (!onTableSelectionClicked) return;

    //     gridRef.current?.gridRef.current.api?.deselectAll();
    // }, [onTableSelectionClicked])

    const handleSelectionChange = useCallback((e: SelectionChangedEvent) => {
        // setOnTableSelectionClicked(true);
        const selectedRows = e.api.getSelectedRows();
        documentPreviewVM.updateSelectedRows(selectedRows);
    }, [documentPreviewVM])

    /*const handleRowDoubleClick = useCallback((docHdr: DocumentPreviewEntity) => {
        documentPreviewVM.onRowDoubleClick(docHdr);
    }, [documentPreviewVM])*/

    const handleGroupButtonClick = useCallback(async (buttonId: string) => {
        documentPreviewVM.onShowLoading();
        if (searchStatus && buttonId === searchStatus) {
            let newSearchCriteria = null;
            newSearchCriteria = { ...EMPTY_DOCUMENT_PREVIEW_SEARCH_CRITERIA }
            newSearchCriteria = {
                ...newSearchCriteria,
                genBy: anaInfoState.userName,
                genDateFrom: moment().subtract(getDefaultBuConfig("REACT_APP_SEARCH_DATA_DEFAULT_DATE_RANGE"), "days").startOf("day").toDate(),
                genDateTo: moment().endOf("day").toDate(),
            };
            documentPreviewVM.searchAllDocPreviewData(operatingUnit, allowUpdateSL, allowUpdateCC);
            await documentPreviewVM.searchDocPreviewData(newSearchCriteria, operatingUnit, allowUpdateSL, allowUpdateCC).then((data) => {
                documentPreviewVM.onHideLoading();
            }).catch(error => {
                documentPreviewVM.onHideLoading();
            }).finally(() => {
                documentPreviewVM.onHideLoading();
            })
        } else {
            await documentPreviewVM.onGroupButtonClick(buttonId, operatingUnit, allowUpdateSL, allowUpdateCC).then((data) => {
                documentPreviewVM.onHideLoading();
            }).catch(error => {
                documentPreviewVM.onHideLoading();
            }).finally(() => {
                documentPreviewVM.onHideLoading();
            })
        }
    }, [anaInfoState.userName, documentPreviewVM, searchStatus, operatingUnit, allowUpdateSL, allowUpdateCC]);

    const isRowSelectable = useCallback((params: any) => {
        if (documentPreviewState.isShowAdjCntrPanel || documentPreviewState.isShowEditPanel) {
            return false;
        } else {
            return true;
        }
    }, [documentPreviewState.isShowAdjCntrPanel, documentPreviewState.isShowEditPanel]);

    const template = useMemo(() => {
        return (
            <>
                <Core.CheckButton
                    checked={isReadyForFinalize}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => { handleGroupButtonClick(e.target.id) }}
                    showBadge={true}
                    badgeValue={isReadyForFinalizeCount > 999 ? '999+' : isReadyForFinalizeCount}
                    disabled={isReadyForFinalizeCount === 0}
                    size="medium"
                    inputId="isReadyForFinalize"
                    label={DOCUMENT_PREVIEW_CONSTANT.NOT_APPROVED_BUT}
                />
            </>
        )
    }, [DOCUMENT_PREVIEW_CONSTANT.NOT_APPROVED_BUT, handleGroupButtonClick, isReadyForFinalize, isReadyForFinalizeCount])

    const memoDocumentPreviewTable = useMemo(() => {

        return (
            <NbisTable
                id='document-preview-table'
                isNewColumnSetting={true}
                columns={documentPreviewState.dynamicTableColumns?.slice()}
                data={transferRowData(documentPreviewList ?? [])}
                showPaginator={false}
                editable={false}
                showAddIcon={false}
                showDeleteButton={false}
                showReloadIcon={false}
                isScrollHighlighted={true}
                selectionMode={false}
                rowSelection={"multiple"}
                isRowHighligted={true}
                handleSelectionChanged={handleSelectionChange}
                //onRowDoubleClick={(e: any, docHdr: DocumentPreviewEntity) => handleRowDoubleClick(docHdr)}
                handleRowSelectable={isRowSelectable}
                gridHeight="customHeight"
                customHeight="calc(100vh - 125px)"
                ref={gridRef}
                headerLabel={
                    <GroupButtons
                        alignment="single-selection"
                        errorMessage=""
                        label=""
                        children={template}
                    />
                }
            />
        );
    }, [documentPreviewList, documentPreviewState.dynamicTableColumns, handleSelectionChange, template, isRowSelectable])

    useEffect(() => {
        if (gridRef.current && gridRef.current.gridRef && gridRef.current.gridRef.current && gridRef.current.gridRef.current.api) {
            gridRef.current.gridRef.current.api.redrawRows();
        }
    }, [documentPreviewState.isShowAdjCntrPanel, documentPreviewState.isShowEditPanel])

    useEffect(() => {
        if (documentPreviewState.isRefresh) {
            if (searchStatus) {
                documentPreviewVM.onGroupButtonClick(searchStatus, operatingUnit, allowUpdateSL, allowUpdateCC).then((data) => {
                    documentPreviewVM.onHideLoading();
                }).catch(error => {
                    documentPreviewVM.onHideLoading();
                }).finally(() => {
                    documentPreviewVM.onHideLoading();
                })
            } else {
                let newSearchCriteria = null;
                newSearchCriteria = { ...EMPTY_DOCUMENT_PREVIEW_SEARCH_CRITERIA }
                newSearchCriteria = {
                    ...newSearchCriteria,
                    genBy: anaInfoState.userName,
                    genDateFrom: moment().subtract(getDefaultBuConfig("REACT_APP_SEARCH_DATA_DEFAULT_DATE_RANGE"), "days").startOf("day").toDate(),
                    genDateTo: moment().endOf("day").toDate(),
                };
                documentPreviewVM.searchAllDocPreviewData(operatingUnit, allowUpdateSL, allowUpdateCC);
                documentPreviewVM.searchDocPreviewData(newSearchCriteria, operatingUnit, allowUpdateSL, allowUpdateCC).then((data) => {
                    documentPreviewVM.onHideLoading();
                }).catch(error => {
                    documentPreviewVM.onHideLoading();
                }).finally(() => {
                    documentPreviewVM.onHideLoading();
                })
            }
        }
    }, [documentPreviewState.isRefresh, searchStatus, operatingUnit, allowUpdateSL, allowUpdateCC, documentPreviewVM, anaInfoState.userName])

    return <><TableWrapper>
        {documentPreviewState.isLoading && <Loader Indicator="Spinner" size="Medium" />}
        {memoDocumentPreviewTable}
    </TableWrapper></>;
}

export default memo(DocumentPreviewTablePanel);
